import { ContentLoader } from '../ContentLoader/index.tsx';

export function CircleButtonLoader() {
  return (
    <ContentLoader width="40px" height="40px">
      <circle cx="20" cy="20" r="20" />
    </ContentLoader>
  );
}
